"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var DashBoardCtl = /** @class */ (function (_super) {
    __extends(DashBoardCtl, _super);
    function DashBoardCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_profit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.profit_amount; });
        _this.dk_deposit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_amount; });
        _this.dk_withdraw_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_amount; });
        // public readonly dk_new_users = UIUtils.IProp2Str((o: IDashBoardBrandDataItem) => { o.new_users });
        _this.dk_players_new = UIUtils_1.UIUtils.IProp2Str(function (o) { o.players_new; });
        _this.dk_players_total = UIUtils_1.UIUtils.IProp2Str(function (o) { o.players_total; });
        _this.dk_players_online = UIUtils_1.UIUtils.IProp2Str(function (o) { o.players_online; });
        _this.dk_currency_symbol = UIUtils_1.UIUtils.IProp2Str(function (o) { o.currency_symbol; });
        _this._errDialog = errDialog;
        return _this;
    }
    DashBoardCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data_by_brands: [],
            common_stat: {
                // new_registered_users_count: 0,
                new_players_count: 0,
                total_players_count: 0,
                total_deposited_amount: 0,
                total_withdraw_amount: 0,
                total_profit: 0,
                total_players_online: 0,
                currency_symbol: ""
            }
        };
    };
    DashBoardCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data_by_brands.length; i++) {
            if (this.DATA.data_by_brands[i].key === id) {
                return this.DATA.data_by_brands[i];
            }
        }
        return null;
    };
    DashBoardCtl.prototype.LoadBrandsData = function (dtRange, onDone) {
        var _this = this;
        webAApi_1.ListDashBoardBrandsStatGet.exec({
            from_year: dtRange.from_year,
            from_month: dtRange.from_month,
            from_day: dtRange.from_day,
            from_hour: dtRange.from_hour,
            from_minute: dtRange.from_minute,
            from_second: dtRange.from_second,
            to_year: dtRange.to_year,
            to_month: dtRange.to_month,
            to_day: dtRange.to_day,
            to_hour: dtRange.to_hour,
            to_minute: dtRange.to_minute,
            to_second: dtRange.to_second
        }, function (resp) {
            _this.DATA.data_by_brands = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data_by_brands.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    profit_amount: resp.list[i].profit_amount,
                    deposit_amount: resp.list[i].deposit_amount,
                    withdraw_amount: resp.list[i].withdraw_amount,
                    // new_users: resp.list[i].new_users,
                    players_new: resp.list[i].players_new,
                    players_total: resp.list[i].players_total,
                    players_online: resp.list[i].players_online,
                    currency_symbol: resp.list[i].currency_symbol
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    DashBoardCtl.prototype.LoadCommonData = function (dtRange, onDone) {
        var _this = this;
        webAApi_1.DetailsDashBoardCommonStatGet.exec({
            from_year: dtRange.from_year,
            from_month: dtRange.from_month,
            from_day: dtRange.from_day,
            from_hour: dtRange.from_hour,
            from_minute: dtRange.from_minute,
            from_second: dtRange.from_second,
            to_year: dtRange.to_year,
            to_month: dtRange.to_month,
            to_day: dtRange.to_day,
            to_hour: dtRange.to_hour,
            to_minute: dtRange.to_minute,
            to_second: dtRange.to_second
        }, function (resp) {
            //  this.DATA.common_stat.new_registered_users_count = resp.new_registered_users_count;
            _this.DATA.common_stat.new_players_count = resp.new_players_count;
            _this.DATA.common_stat.total_players_count = resp.total_players_count;
            _this.DATA.common_stat.total_deposited_amount = resp.total_deposited_amount;
            _this.DATA.common_stat.total_withdraw_amount = resp.total_withdraw_amount;
            _this.DATA.common_stat.total_profit = resp.total_profit;
            _this.DATA.common_stat.total_players_online = resp.total_players_online;
            _this.DATA.common_stat.currency_symbol = resp.currency_symbol;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    DashBoardCtl.prototype.GetULoginTestData = function (key, onDone) {
        var _this = this;
        webAApi_1.DoGetAdminPassword.exec({ data: { admin_id: key } }, function (resp) {
            if (onDone) {
                onDone(resp.password);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return DashBoardCtl;
}(BaseController_1.BaseController));
exports.DashBoardCtl = DashBoardCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_dashboard/ctl/DashBoardCtl.ts
// module id = 866
// module chunks = 0